import apiClient from '../../utils/apiClient';
import {
  GetAllCategoriesParams,
  GetAllCategoriesResponse,
  GetProductsByCategoryParams,
  GetProductsByCategoryResponse,
} from './categoryModels';

/**
 * Get all categories with pagination and filtering
 * @param params - Query parameters for pagination, sorting, and search
 * @returns Promise with categories list and pagination info
 */
export const fetchAllCategories = async (
  params: GetAllCategoriesParams = {}
): Promise<GetAllCategoriesResponse> => {
  const {
    page = 1,
    limit = 10,
    sortBy = 'categoryName',
    sortOrder = 'asc',
    search = '',
  } = params;

  const response = await apiClient.get<GetAllCategoriesResponse>('/categories', {
    params: { page, limit, sortBy, sortOrder, search },
  });
  return response.data;
};

/**
 * Get products by category with pagination and sorting
 * @param categoryId - Category ID
 * @param params - Query parameters for pagination and sorting
 * @returns Promise with category info, products, and pagination info
 */
export const fetchProductsByCategory = async (
  categoryId: string,
  params: GetProductsByCategoryParams = {}
): Promise<GetProductsByCategoryResponse> => {
  const {
    page = 1,
    limit = 20,
    sortBy = 'productOrder',
    sortOrder = 'asc',
  } = params;

  const response = await apiClient.get<GetProductsByCategoryResponse>(
    `/categories/${categoryId}/products`,
    {
      params: { page, limit, sortBy, sortOrder },
    }
  );
  return response.data;
};

